import React, { useState, useEffect } from "react";
import { Phone, Mail, MapPin, ArrowLeft } from "lucide-react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { useNavigate } from "react-router-dom";
import { getWithoutTokenAPI } from "../util/Api";

const ContactUs = () => {
  const navigate = useNavigate();
  const [contactData, setContactData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFooter = async () => {
      try {
        const response = await getWithoutTokenAPI("/footer/get_all");
        if (response?.statusCode === 200 && response.data) {
          const data = Array.isArray(response.data) ? response.data[0] : response.data;
          setContactData(data);
        }
      } catch (error) {
        console.error("Error fetching contact data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchFooter();
  }, []);

  return (
    <>
      <Header />

      {/* Back link */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <button
              onClick={() => navigate("/")}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-900 transition-colors cursor-pointer"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="text-base font-medium">Back</span>
            </button>
          </div>
        </div>
      </div>

      {/* Page Content */}
      <div style={{minHeight: "100vh", paddingTop: "2rem", backgroundColor: "#f9fafb"}}>
        <div
          style={{
            width: "90%",
            maxWidth: "700px",
            margin: "0 auto 4rem auto",
            backgroundColor: "white",
            padding: "3rem",
            borderRadius: "16px",
            boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
          }}
        >
          {/* Header */}
          <div
            style={{
              textAlign: "center",
              marginBottom: "2.5rem",
              paddingBottom: "2rem",
              borderBottom: "2px solid #fee2e2",
            }}
          >
            <h1
              style={{
                fontSize: "2.5rem",
                fontWeight: "700",
                background: "linear-gradient(to right bottom, rgb(220, 38, 38), rgb(243, 67, 67))",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
                margin: 0,
                lineHeight: 1.2,
              }}
            >
              Contact Us
            </h1>
            <p style={{ fontSize: "1rem", color: "#6b7280", marginTop: "1rem" }}>
              We'd love to hear from you. Get in touch with us using the details below.
            </p>
          </div>

          {/* Contact Details */}
          {loading ? (
            <div style={{ textAlign: "center", padding: "2rem", color: "#9ca3af" }}>Loading...</div>
          ) : (
            <div className="space-y-6">
              {contactData?.PhoneNumber && (
                <div className="flex items-start gap-4 p-4 rounded-xl border border-gray-100 hover:border-red-100 hover:bg-red-50 transition-colors">
                  <div className="p-3 bg-red-100 rounded-lg text-red-600">
                    <Phone className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Phone Number</h3>
                    <p className="text-gray-600">{contactData.PhoneNumber}</p>
                  </div>
                </div>
              )}

              {contactData?.EmailAddress && (
                <div className="flex items-start gap-4 p-4 rounded-xl border border-gray-100 hover:border-red-100 hover:bg-red-50 transition-colors">
                  <div className="p-3 bg-red-100 rounded-lg text-red-600">
                    <Mail className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Email Address</h3>
                    <a href={`mailto:${contactData.EmailAddress}`} className="text-red-600 hover:underline">
                      {contactData.EmailAddress}
                    </a>
                  </div>
                </div>
              )}

              {contactData?.OfficeAddress && contactData?.OfficeAddress?.en && (
                <div className="flex items-start gap-4 p-4 rounded-xl border border-gray-100 hover:border-red-100 hover:bg-red-50 transition-colors">
                  <div className="p-3 bg-red-100 rounded-lg text-red-600">
                    <MapPin className="w-6 h-6" />
                  </div>
                  <div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-1">Office Address</h3>
                    <p className="text-gray-600">{contactData.OfficeAddress.en}</p>
                  </div>
                </div>
              )}

              {(!contactData?.PhoneNumber && !contactData?.EmailAddress && (!contactData?.OfficeAddress || !contactData?.OfficeAddress?.en)) && (
                <div style={{ textAlign: "center", color: "#6b7280", padding: "2rem" }}>
                  <p>Contact details will be updated soon.</p>
                </div>
              )}
            </div>
          )}
        </div>

        <Footer />
      </div>
    </>
  );
};

export default ContactUs;
